<button (click)='clickBtn()' [disabled]='selectedRows === undefined || selectedRows?.length === 0'
        class='btn pt-btn-upload btn-sm d-flex'
        type='button'>
  <pt-icon [key]='IconDownload' [size]="14" class="hstack"></pt-icon>
  <span class="mx-1">{{ 'BUTTON.DOWNLOAD' | translate }}</span>
  <span *ngIf='selectedRows?.length > 0'>({{ selectedRows.length }})</span>
</button>
